import Mutations from '../../odata/mutations';

export default { ...new Mutations('userSignature'), ...new Mutations('userSignatures') };
